import { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Container, Row, Stack } from "react-bootstrap";
import { useNavigate } from "react-router";
import { getAllMovementBreakStrands, getAllStrandsNew } from "../../firebase";
import { UserContext } from "../../providers/UserProvider";
import StructuredLessonItem from "../../components/StructuredLessonItem";
import StrandCategoryBox from "../../components/new-components/StrandCategoryBox";
import { Link } from "react-router-dom";
import AsyncComponent from "../../components/generic/AsyncComponent";
import { checkIfStrandIsEmpty } from "../../functions/lessonFunctions";

import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

import pdf1 from "../../pdfs/23_24 Infants LTP.pdf";
import pdf2 from "../../pdfs/23_24 1st 2nd LTP.pdf";
import pdf3 from "../../pdfs/23_24 3rd 4th LTP.pdf";
import pdf4 from "../../pdfs/23_24 5th 6th LTP.pdf";
import pdf5 from "../../pdfs/SD Infants.pdf";
import pdf6 from "../../pdfs/SD 1st 2nd.pdf";
import pdf7 from "../../pdfs/SD 3rd 4th.pdf";
import pdf8 from "../../pdfs/SD 5th 6th.pdf";
// 2024-25 LTPs
import pdf9 from "../../pdfs/Infants LTP 24_25.pdf";
import pdf10 from "../../pdfs/1st & 2nd LTP 24_25.pdf";
import pdf11 from "../../pdfs/3rd & 4th LTP 24_25.pdf";
import pdf12 from "../../pdfs/5th & 6th LTP 24_25.pdf";

function YearContentPage2() {
  const [strandsText, setStrandsText] = useState("");
  const [strands, setStrands] = useState([]);
  const [loading, setLoading] = useState(false);
  const { data, data2 } = useContext(UserContext);
  const [subscribed, setSubscribed] = useState(true)
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Daly Exercise+ | Content";
    fetchData(data2);
  }, [data2]);

  const fetchData = async (data2) => {
    const yearMapping = {
      0: "Junior & Senior",
      1: "1st & 2nd",
      2: "3rd & 4th",
      3: "5th & 6th",
      10: "Mild SEN",
      11: "Moderate SEN",
      12: "Severe-Profound SEN",
    };
    if (data2.Year === 0) {
      setStrandsText("Junior & Senior");
    } else if (data2.Year === 1) {
      setStrandsText("1st & 2nd");
    } else if (data2.Year === 2) {
      setStrandsText("3rd & 4th");
    } else if (data2.Year === 3) {
      setStrandsText("5th & 6th");
    } else if (data2.Year === 10) {
      setStrandsText("Mild SEN");
    } else if (data2.Year === 11) {
      setStrandsText("Moderate SEN");
    } else if (data2.Year === 12) {
      setStrandsText("Severe-Profound SEN");
    }
    setLoading(false);
  };

  const goToStrand = (guid) => navigate(guid);

  const getPDFLink = () => {
    if (data2.Year === 0) {
      return pdf9;
    }
    if (data2.Year === 1) {
      return pdf10;
    }
    if (data2.Year === 2) {
      return pdf11;
    }
    if (data2.Year === 3) {
      return pdf12;
    }
    return pdf1;
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    // console.log(numPages);
  };

  const iosLink = () => {
    let url =
      "https://apps.apple.com/ie/app/daly-exercise/id1586325510?platform=iphone";
    window.open(url, "_blank").focus();
  };

  const instagramLink = () => {
    let url = "https://www.instagram.com/dalyexercise/";
    window.open(url, "_blank").focus();
  };

  const tiktokLink = () => {
    let url = "https://www.tiktok.com/@dalyexercise";
    window.open(url, "_blank").focus();
  };

  const androidLink = () => {
    let url =
      "https://play.google.com/store/apps/details?id=com.dalyexercise.dalyexerciseplus";
    window.open(url, "_blank").focus();
  };

  

  const manageCodes = () => {
    if (subscribed) {
      navigate("/manage-school/school");
    } else {
      navigate("/subscription");
    }
  };

  const options = {
    weekday: "long",
    month: "long",
    day: "numeric",
  };

  return (
    // <Container fluid>
    //   <div className="dashboard-body">
    //     <Container>
    //       <h1 className="pageTitle title-margin flex-grow-1">
    //         {strandsText} Curriculum
    //       </h1>
    //       <Row className="full-height">
    //         <Col md={6}>
    //           <div className="white-box equal-height">
    //             <h2 className="text-center title-margin flex-grow-1">
    //               Follow Our Currated Lesson Plans
    //             </h2>
    //             <div className=" d-flex justify-content-center">
    //               {/* <Document
    //                 className={"w-70"}
    //                 file={getPDFLink()}
    //                 onLoadSuccess={onDocumentLoadSuccess}
    //                 onLoadError={console.error}
    //               >
    //                 <Page pageNumber={1} />
    //               </Document> */}
    //             </div>
    //             <hr/>
    //             <Stack direction="horizontal" className="ps-3 pe-3">
    //               <div>Lesson 5</div>
    //               <div className="ms-auto">10% Complete</div>
    //             </Stack>
    //           </div>
    //         </Col>
    //         <Col md={6}>
    //           <div className="white-box equal-height">
    //             <h2 className="text-center title-margin flex-grow-1">
    //               Explore Everything
    //             </h2>
    //             <Row>
    //               <Col md={6}>
    //                 <StrandCategoryBox
    //                   title={"All Lessons"}
    //                   icon={"icon_lessons_tab"}
    //                   color={"purple"}
    //                   content={"PE Strands"}
    //                   // click={() => goToStrand(strand.Guid)}
    //                 ></StrandCategoryBox>
    //               </Col>
    //               <Col md={6}>
    //                 <StrandCategoryBox
    //                   title={"All Lessons"}
    //                   icon={"icon_brainbreak_tab"}
    //                   color={"blue"}
    //                   content={"Movement Breaks"}
    //                   // click={() => goToStrand(strand.Guid)}
    //                 ></StrandCategoryBox>
    //               </Col>
    //             </Row>
    //             <br />
    //           </div>
    //         </Col>
    //       </Row>
    //     </Container>
    //   </div>
    // </Container>
    <Container fluid>
    <div className="dashboard-body full-page-length">
      <Container fluid>
        <Stack className="dashboard-header-2" direction="horizontal">
          <h3>
            <b>{strandsText} Curriculum</b>
          </h3>
          <div className="dashboard-date ms-auto text-end h3">
            <b>{new Date().toLocaleDateString(undefined, options)}</b>
          </div>
        </Stack>
        <Col>
          <Row>
            <Col xl={3} lg={6} md={6} sm={6} xs={12}>
              <Link to={"/structured-lessons"} className={"text-link"}>
                <Card
                  style={{ height: "200px" }}
                  className="mb-3 p-3 plan-card-highlight grow"
                >
                  <Stack direction="horizontal" className="my-auto">
                    <Stack className="my-auto text-center">
                      <div className="h2">Structured</div>
                      <div className="h2">Lessons!</div>
                    </Stack>
                    <img
                      src="/icons/icon_games.png"
                      style={{ height: "7rem", width: "7rem" }}
                    ></img>
                  </Stack>
                </Card>
              </Link>
            </Col>
            <Col xl={3} lg={6} md={6} sm={6} xs={12}>
              <Card
                style={{ height: "200px" }}
                onClick={() => manageCodes()}
                className="mb-3 p-3 welcome-back-card grow"
              >
                <Stack direction="horizontal" className="my-auto">
                  {subscribed ? (
                    <Stack className="my-auto text-center">
                      <div className="headingColour h2">My School</div>
                    </Stack>
                  ) : (
                    <Stack className="my-auto text-center">
                      <div className="headingColour h2">Subscribe Now!</div>
                    </Stack>
                  )}

                  <img
                    src="/icons/high_res_logo_icon.png"
                    style={{ width: "35%" }}
                  ></img>
                </Stack>
              </Card>
            </Col>

            <Col xl={3} lg={6} md={6} sm={6} xs={12}>
              <Card
                style={{ height: "200px" }}
                className="mb-3 p-3 grow instagram-store-card"
                onClick={() => instagramLink()}
              >
                <Stack direction="horizontal" className="my-auto">
                  <Stack className="my-auto text-center p-auto">
                    <div className=" h2"></div>
                    <div className=" h2">PE Videos</div>
                  </Stack>

                  <img
                    src="/icons/icon_lessons_tab.png"
                    style={{ width: "55%" }}
                  ></img>
                </Stack>
              </Card>
            </Col>
            <Col xl={3} lg={6} md={6} sm={6} xs={12}>
              <Card
                style={{ height: "200px" }}
                className="mb-3 p-3 grow tiktok-store-card"
                onClick={() => tiktokLink()}
              >
                <Stack direction="horizontal" className="my-auto">
                  <Stack className="my-auto text-center p-auto">
                    <div className=" h2">Movement Breaks</div>
                  </Stack>

                  <img
                    src="/icons/icon_.png"
                    style={{ width: "40%" }}
                  ></img>
                </Stack>
              </Card>
            </Col>
          </Row>
          {/* <Row>
            <Col xl={6} lg={6} md={6} sm={12} xs={12}>
              <Card style={{ minHeight: "450px" }} className="mb-3">
                <Stack>
                  <Stack direction="horizontal" className="p-3">
                    <h2 className="pageTitle m-2">
                      <b>Schedule</b>
                    </h2>
                    <div className="ms-auto h5 m-2 my-auto text-end">
                      <b>What's on today?</b>
                    </div>
                  </Stack>
                  <hr style={{ marginTop: 0 }} className="light-line" />
                  <Row>
                    {Object.values(scheduleItems).length > 0 ? (
                      <Col
                        className="px-3 col-border-right"
                        lg={6}
                        md={12}
                        sm={12}
                      >
                        {Object.values(scheduleItems).map((item, i) => {
                          if (i < 3)
                            return (
                              <div key={i}>
                                <ScheduleItem Item={item} />
                              </div>
                            );
                        })}
                      </Col>
                    ) : (
                      <h4 className="text-center my-3">
                        <b>You've nothing scheduled today</b>
                      </h4>
                    )}

                    {Object.values(scheduleItems).length > 0 ? (
                      <Col className="px-3" lg={6} md={12} sm={12}>
                        {Object.values(scheduleItems).map((item, i) => {
                          if (i >= 3 && i < 6) {
                            return (
                              <div key={i}>
                                <ScheduleItem Item={item} />
                              </div>
                            );
                          }
                        })}
                      </Col>
                    ) : (
                      <></>
                    )}
                  </Row>

                  <div className="p-3 mt-auto">
                    <Link to={`/schedule`} className="text-link d-grid">
                      <Button variant="primary" className="mainButton">
                        <b>My Schedule</b>
                      </Button>
                    </Link>
                  </div>
                </Stack>
              </Card>
            </Col>
          </Row> */}
        </Col>
      </Container>
    </div>
  </Container>
  );
}

export default YearContentPage2;
